import "../../../../content/departments/sites/corp.css";
import * as React from 'react';
export default {
  React
};